<template>
  <div>
    <TopHeader2></TopHeader2>
    <main class="main">
      <PagesPath :items="['درباره ی ما']" :last="'about-us'"></PagesPath>
      <section v-if="homeData" class="p-md-3 pb-3 marginTop box-shaddow20 border-radius10 container">
        <h5 class="text-color-444 my-4 weight-bold text-right">{{homeData.settings.about_title}}</h5>
        <p class="line-height2-5 text-color-666 fontsize14 text-justify">
          {{homeData.settings.about_body1}}
        </p>
        <section class="bg-color-eai d-flex flex-wrap  px-3 pt-3 border-radius10 my-4">
          <div v-for="(item,index) in homeData.settings.about_trait" :key="index" class="ml-md-4 ml-3 mb-3">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.67012 1.99991H16.3401C19.7301 1.99991 22.0001 4.37991 22.0001 7.91991V16.0909C22.0001 19.6199 19.7301 21.9999 16.3401 21.9999H7.67012C4.28012 21.9999 2.00012 19.6199 2.00012 16.0909V7.91991C2.00012 4.37991 4.28012 1.99991 7.67012 1.99991ZM11.4301 14.9899L16.1801 10.2399C16.5201 9.89991 16.5201 9.34991 16.1801 8.99991C15.8401 8.65991 15.2801 8.65991 14.9401 8.99991L10.8101 13.1299L9.06012 11.3799C8.72012 11.0399 8.16012 11.0399 7.82012 11.3799C7.48012 11.7199 7.48012 12.2699 7.82012 12.6199L10.2001 14.9899C10.3701 15.1599 10.5901 15.2399 10.8101 15.2399C11.0401 15.2399 11.2601 15.1599 11.4301 14.9899Z" fill="#ccc"/>
            </svg>
            <span class="fontsize13 text-color-666 mr-1">{{item}}</span>
          </div>
        </section>
        <p class="line-height2-5 text-color-666 fontsize14 text-justify">{{homeData.settings.about_body2}}
        </p>
        <BenefitsOrthodontics class="mb-5"></BenefitsOrthodontics>

        <p class="line-height2-5 text-color-666 fontsize14 text-justify">{{homeData.settings.about_body3}}
        </p>

        <div class="about-us-why mt-4 mb-5">
          <div class="about-us-why-img">
            <img :src="'https://www.gorgon.ir/storage/'+homeData.settings.about_image" alt="">
          </div>
          <div>
            <h5 class="text-right text-color-444 weight-bold">چرا ما ... ؟</h5>
            <p class="line-height2-5 text-color-666 fontsize14 text-justify">{{homeData.settings.about_body4}}
            </p>
          </div>
        </div>
      </section>
    </main>

  </div>
</template>

<script>
import TopHeader2 from "../components/TopHeader2";
import PagesPath from "../components/PagesPath";
import BenefitsOrthodontics from "../components/BenefitsOrthodontics";
export default {
  name: "AboutUs",
  components:{
    TopHeader2,
    PagesPath,
    BenefitsOrthodontics
  },
  computed:{
        homeData(){
      return this.$root.homeData
    },
  },
    metaInfo() {
    return {
      title:"درباره ما ",
      meta: [
        {
          name: "description",
          content:"وبسایت دکتر صادقی فوق تخصص جراحی دندان و اولین ایرانی تولید کننده ارتودنسی های نامرئی"
        },
      ]
    };
  },
  mounted() {
    const aboutUsImg=document.querySelectorAll('.buy-benefits-img img');
    for (let aboutUsImgItem of aboutUsImg){
      aboutUsImgItem.style.height = (aboutUsImgItem.offsetWidth /1.5) + "px";
    }


    const aboutUsImg2=document.querySelectorAll('.about-us-why-img')[0];
    aboutUsImg2.style.height = (aboutUsImg2.offsetWidth / 1.5) + "px";

  }
}
</script>

<style scoped>
/****============== start about us =================****/
.buy-benefits-grid{
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 15px;
}
.buy-benefits-svg{
  width: 40px;
  height: 40px;
  position: relative;
  flex-shrink: 0 ;
}
.buy-benefits-svg svg{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50% , -50%);
}
.buy-benefits-img div{
  /*height: 150px;*/
  width: 100%;
  position: relative;
  overflow: hidden;
}
.buy-benefits-img div img{
  width: 100%;
  height: 100%;
}
.about-us-why{
  display: grid;
  grid-template-columns: 1fr 2fr;
  grid-gap: 15px;
}
.about-us-why-img{
  width: 100%;
  height: 350px;
  border-radius: 10px;
  overflow: hidden;
}
.about-us-why-img img{
  min-height: 100%;
  width: 100%;
}
/****============== End about us =================****/
@media screen and (max-width: 991px){
  .about-us-why{
    grid-template-columns: 1fr 1fr;
  }
}
@media screen and (max-width: 767px){
  .about-us-why {
    grid-template-columns: 1fr;
  }
  .buy-benefits-grid{
    grid-template-columns: 1fr;
  }
}
@media screen and (max-width: 575px){
  .about-us-why {
    grid-template-columns: 1fr ;
  }
}
</style>